import { formatNumber, formatPercentValue, getNumberLocale } from '@indusketch/project-model';

export {
  formatArea,
  formatLength,
  formatNumber,
  parseLength,
  type DisplayUnit,
} from '@indusketch/project-model';

export const formatPercent = (ratio: number): string => formatPercentValue(ratio, 1);

/** Prefilled value of a text field: no thousands separator, which `parseLength` would misread. */
export const inputNumber = (value: number, maxDecimals = 2): string =>
  new Intl.NumberFormat(getNumberLocale(), {
    maximumFractionDigits: maxDecimals,
    useGrouping: false,
  }).format(value);

/** Degrees rounded to 0.1° for display; avoids "89.99999°" after float round-trips. */
export function radToDegSafe(rad: number): string {
  const deg = Math.round(((rad * 180) / Math.PI) * 10) / 10;
  return formatNumber(Object.is(deg, -0) ? 0 : deg, 1);
}
